export default __webpack_public_path__ + "static/StartUp-be60837049bd39d40d9765396709b955.png";